/* The Goodieez theme JS: menu, AJAX cart drawer, product form, small helpers */
(function () {
  'use strict';
  var G = window.Goodieez || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function formatMoney(cents) {
    var fmt = G.moneyFormat || '${{amount}}';
    var v = (cents / 100);
    var withDelims = function (n, d, t, s) {
      var parts = n.toFixed(d).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, t);
      return parts.join(s);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount_no_decimals': return withDelims(v, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(v, 0, '.', ',');
        default: return withDelims(v, 2, ',', '.');
      }
    });
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }

  /* Toast */
  var tt;
  function toast(msg) {
    var el = $('#GoodieToast'); if (!el) return;
    el.textContent = msg; el.classList.add('show');
    clearTimeout(tt); tt = setTimeout(function () { el.classList.remove('show'); }, 2400);
  }

  /* Mobile menu: see v2 block below */

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-step]'); if (!b) return;
    var input = b.parentElement.querySelector('input[type=number]'); if (!input) return;
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qtyStep, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Auto-submit (collection filters, sort, cart page qty) */
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-autosubmit]')) {
      var f = e.target.form;
      if (f && f.id === 'CartPageForm') { clearTimeout(f._t); f._t = setTimeout(function () { f.requestSubmit ? f.requestSubmit() : f.submit(); }, 500); }
      else if (f) f.submit();
    }
  });

  /* Product page: variant picker + gallery */
  var pform = $('#ProductForm');
  if (pform) {
    var select = $('#ProductVariantSelect', pform);
    var radios = $$('input[data-option-index]', pform);
    var addBtn = $('#AddToCart');
    var mainImg = $('#ProductMainImage');
    var addLabel = addBtn ? addBtn.textContent : '';
    var update = function () {
      var chosen = [];
      radios.forEach(function (r) { if (r.checked) chosen[r.dataset.optionIndex] = r.value; });
      var match = null;
      Array.prototype.forEach.call(select.options, function (o) { if (o.dataset.options === chosen.join('||')) match = o; });
      if (!match) { addBtn.disabled = true; addBtn.textContent = '—'; return; }
      select.value = match.value;
      var unavailable = match.hasAttribute('data-unavailable');
      addBtn.disabled = unavailable;
      addBtn.textContent = unavailable ? (G.strings.soldOut || 'Sold out') : addLabel;
      var price = $('#ProductPrice');
      if (price) price.innerHTML = '<span class="price-wrap"><span class="price' + (match.dataset.compare ? ' price--sale' : '') + '">' + match.dataset.price + '</span>' + (match.dataset.compare ? '<s class="price-compare">' + match.dataset.compare + '</s>' : '') + '</span>';
      if (match.dataset.image && mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = match.dataset.image; }
      var url = new URL(window.location.href); url.searchParams.set('variant', match.value);
      window.history.replaceState({}, '', url.toString());
    };
    radios.forEach(function (r) { r.addEventListener('change', update); });
    $$('.thumb-btn').forEach(function (b) {
      b.addEventListener('click', function () { if (mainImg) { mainImg.removeAttribute('srcset'); mainImg.src = b.dataset.full; } });
    });
  }

  /* ---------- AJAX cart ---------- */
  var drawer = $('#CartDrawer'), overlay = $('#CartOverlay');
  var useDrawer = G.cartType !== 'page' && drawer;

  function openCart() {
    if (!useDrawer) { window.location.href = G.routes.cart; return; }
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    overlay.hidden = false; document.body.style.overflow = 'hidden';
    drawer.focus();
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
    overlay.hidden = true; document.body.style.overflow = '';
  }
  if (overlay) overlay.addEventListener('click', closeCart);
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeCart); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
  var toggle = $('#CartToggle');
  if (toggle && useDrawer) toggle.addEventListener('click', function (e) { e.preventDefault(); fetchCart().then(openCart); });

  function bump(count) {
    var c = $('#CartCount'); if (!c) return;
    c.textContent = count; c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
  }

  function renderCart(cart) {
    bump(cart.item_count);
    if (!drawer) return cart;
    $('#CartSubtotal').textContent = formatMoney(cart.total_price);
    var co = $('#CartCheckout'); if (co) co.disabled = cart.item_count === 0;
    var meter = $('#CartShipMeter');
    if (meter) {
      if (G.freeShipping > 0) {
        var left = Math.max(0, G.freeShipping - cart.total_price);
        var pct = Math.min(100, cart.total_price / G.freeShipping * 100);
        meter.innerHTML = (left > 0 ? '🚚 ' + esc(G.strings.freeLeft).replace('[amount]', '<b>' + esc(formatMoney(left)) + '</b>') : '🎉 ' + esc(G.strings.freeDone)) +
          '<div class="bar"><i style="width:' + pct + '%"></i></div>';
      } else meter.innerHTML = '';
    }
    var items = $('#CartItems');
    if (!cart.items.length) {
      items.innerHTML = '<div class="drawer-empty"><div>🛍️</div><p>' + esc(G.strings.empty) + '</p></div>';
      return cart;
    }
    items.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + esc(it.image) + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=160" alt="" loading="lazy" width="64" height="64">' : '<span style="font-size:2rem" aria-hidden="true">🍬</span>';
      var variant = it.variant_title && it.product_has_only_default_variant === false ? '<div class="lp">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="line" data-key="' + esc(it.key) + '">' +
        '<a class="thumb" href="' + esc(it.url) + '" style="background:#fff">' + img + '</a>' +
        '<div><h4><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></h4>' + variant +
        '<div class="lp">' + esc(formatMoney(it.final_price)) + '</div></div>' +
        '<div class="line-right"><div class="qty">' +
        '<button type="button" data-change="' + (it.quantity - 1) + '" aria-label="' + esc(G.strings.decrease) + '">−</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-change="' + (it.quantity + 1) + '" aria-label="' + esc(G.strings.increase) + '">+</button></div>' +
        '<button type="button" class="remove" data-change="0">' + esc(G.strings.remove) + '</button></div></div>';
    }).join('');
    return cart;
  }

  function fetchCart() {
    return fetch(G.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(renderCart);
  }

  if (drawer) {
    $('#CartItems').addEventListener('click', function (e) {
      var b = e.target.closest('[data-change]'); if (!b) return;
      var line = b.closest('.line'); var items = $('#CartItems');
      items.classList.add('loading');
      fetch(G.routes.cartChange + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.dataset.key, quantity: parseInt(b.dataset.change, 10) })
      }).then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(renderCart)
        .catch(function () { toast(G.strings.error); })
        .finally(function () { items.classList.remove('loading'); });
    });
  }

  /* Intercept product forms (product page + quick add) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('js-ajax-cart')) return;
    if (!useDrawer) return; // fall back to normal form post when cart type = page
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'); if (btn) btn.disabled = true;
    fetch(G.routes.cartAdd + '.js', {
      method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (item) {
      var title = (item.items ? item.items[0].product_title : item.product_title) || '';
      toast('🍬 ' + title + ' ' + G.strings.added);
      return fetchCart().then(openCart);
    }).catch(function (err) {
      toast((err && (err.description || err.message)) || G.strings.error);
    }).finally(function () { if (btn) btn.disabled = false; });
  });

  if (drawer) fetchCart().catch(function () {});
})();

/* ===== v2: header mega menu, mobile drawer, predictive search, facets, product rows, recommendations ===== */
(function () {
  'use strict';
  var G = window.Goodieez || { routes: {}, strings: {} };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var hoverable = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- Desktop mega menu + dropdowns ---------- */
  var megaItems = $$('[data-mega]');
  function setMega(item, open) {
    item.classList.toggle('open', open);
    var btn = item.querySelector('.mega-toggle');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  function closeAllMega(except) { megaItems.forEach(function (i) { if (i !== except) setMega(i, false); }); }
  megaItems.forEach(function (item) {
    var btn = item.querySelector('.mega-toggle'); if (!btn) return;
    var t;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      // a hover just opened it: keep it open instead of toggling it shut
      if (item.classList.contains('open') && Date.now() - (item._hoverAt || 0) < 700) return;
      var open = !item.classList.contains('open');
      closeAllMega(item); setMega(item, open);
    });
    if (hoverable) {
      item.addEventListener('mouseenter', function () { clearTimeout(t); if (!item.classList.contains('open')) item._hoverAt = Date.now(); closeAllMega(item); setMega(item, true); });
      item.addEventListener('mouseleave', function () { t = setTimeout(function () { setMega(item, false); }, 160); });
    }
    item.addEventListener('focusout', function (e) { if (!item.contains(e.relatedTarget)) setMega(item, false); });
  });
  document.addEventListener('click', function (e) { if (!e.target.closest('[data-mega]')) closeAllMega(); });

  /* ---------- Mobile nav drawer ---------- */
  var mnav = $('#MobileNav'), mover = $('#MobileNavOverlay'), mbtn = $('#MenuToggle');
  function openNav() {
    if (!mnav) return;
    mnav.classList.add('open'); mnav.setAttribute('aria-hidden', 'false');
    if (mover) mover.hidden = false;
    document.body.classList.add('nav-open');
    if (mbtn) mbtn.setAttribute('aria-expanded', 'true');
    mnav.focus();
  }
  function closeNav() {
    if (!mnav || !mnav.classList.contains('open')) return;
    mnav.classList.remove('open'); mnav.setAttribute('aria-hidden', 'true');
    if (mover) mover.hidden = true;
    document.body.classList.remove('nav-open');
    if (mbtn) { mbtn.setAttribute('aria-expanded', 'false'); mbtn.focus(); }
  }
  if (mbtn) mbtn.addEventListener('click', openNav);
  $$('[data-mnav-close]').forEach(function (b) { b.addEventListener('click', closeNav); });
  window.addEventListener('resize', function () { if (window.innerWidth > 1060) closeNav(); });

  /* ---------- Predictive search ---------- */
  var ps = $('[data-predictive-search]');
  if (ps) {
    var input = $('.hs-input', ps), results = $('[data-predictive-results]', ps), clearBtn = $('[data-search-clear]', ps);
    var toggle = $('[data-search-toggle]');
    var ctrl, timer, lastQ = '', active = -1;
    var close = function () { results.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; };
    var open = function () { if (results.innerHTML.trim()) { results.hidden = false; input.setAttribute('aria-expanded', 'true'); } };
    var options = function () { return $$('[role="option"]', results); };
    var highlight = function (i) {
      var opts = options(); if (!opts.length) return;
      active = (i + opts.length) % opts.length;
      opts.forEach(function (o, k) { o.setAttribute('aria-selected', k === active ? 'true' : 'false'); });
      input.setAttribute('aria-activedescendant', opts[active].id);
      opts[active].scrollIntoView({ block: 'nearest' });
    };
    var fetchResults = function (q) {
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      results.classList.add('is-loading');
      var url = (G.routes.predictiveSearch || '/search/suggest') + '?q=' + encodeURIComponent(q) +
        '&' + encodeURIComponent('resources[type]') + '=product,collection,query' +
        '&' + encodeURIComponent('resources[limit]') + '=6' +
        '&' + encodeURIComponent('resources[options][unavailable_products]') + '=last' +
        '&section_id=predictive-search';
      fetch(url, ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('#PredictiveSearchResults');
          results.innerHTML = el ? el.outerHTML : '';
          results.classList.remove('is-loading'); active = -1;
          if (input.value.trim() === q) open();
        })
        .catch(function (err) { if (!err || err.name !== 'AbortError') { results.classList.remove('is-loading'); close(); } });
    };
    input.addEventListener('input', function () {
      var q = input.value.trim();
      if (clearBtn) clearBtn.hidden = !input.value;
      clearTimeout(timer);
      if (!q) { lastQ = ''; results.innerHTML = ''; close(); return; }
      timer = setTimeout(function () { if (q !== lastQ) { lastQ = q; fetchResults(q); } else open(); }, 220);
    });
    input.addEventListener('focus', function () { if (input.value.trim()) open(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (results.hidden) open(); highlight(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); highlight(active - 1); }
      else if (e.key === 'Enter' && active > -1) { var a = options()[active].querySelector('a'); if (a) { e.preventDefault(); window.location.href = a.href; } }
      else if (e.key === 'Escape') { close(); }
    });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; clearBtn.hidden = true; results.innerHTML = ''; close(); input.focus(); });
    document.addEventListener('click', function (e) { if (!ps.contains(e.target) && !(toggle && toggle.contains(e.target))) close(); });
    if (toggle) toggle.addEventListener('click', function () {
      var isOpen = ps.classList.toggle('open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      if (isOpen) input.focus(); else close();
    });
  }

  /* ---------- Global Escape ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closeAllMega(); closeNav(); closeFacets();
  });

  /* ---------- Facets (filters + sort) ---------- */
  var facetForm = $('[data-facet-form]'), facets = $('[data-facets-drawer]'), facetsOverlay = $('.facets-overlay');
  var isDrawer = function () { return window.matchMedia('(max-width: 900px)').matches; };
  function submitFacets() {
    if (!facetForm) return;
    // drop empty price inputs so the URL stays clean
    $$('input[type=number]', facetForm).forEach(function (i) { i.disabled = i.value === ''; });
    facetForm.submit();
  }
  function openFacets() {
    if (!facets) return;
    facets.classList.add('open'); if (facetsOverlay) facetsOverlay.hidden = false;
    document.body.classList.add('nav-open');
    $$('[data-facets-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    facets.focus();
  }
  function closeFacets() {
    if (!facets || !facets.classList.contains('open')) return;
    facets.classList.remove('open'); if (facetsOverlay) facetsOverlay.hidden = true;
    document.body.classList.remove('nav-open');
    $$('[data-facets-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
  }
  $$('[data-facets-open]').forEach(function (b) { b.addEventListener('click', openFacets); });
  $$('[data-facets-close]').forEach(function (b) { b.addEventListener('click', closeFacets); });
  if (facetForm) {
    facetForm.addEventListener('change', function (e) {
      if (e.target.matches('[data-facet-input]') && !isDrawer()) submitFacets();
    });
    facetForm.addEventListener('submit', function (e) { e.preventDefault(); submitFacets(); });
  }
  var sortSel = $('[data-sort-select]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var mirror = facetForm && $('[data-sort-mirror]', facetForm);
    if (mirror) { mirror.value = sortSel.value; submitFacets(); }
    else { var u = new URL(window.location.href); u.searchParams.set('sort_by', sortSel.value); u.searchParams.delete('page'); window.location.href = u.toString(); }
  });

  /* ---------- Scrolling product rows (prev/next buttons) ---------- */
  $$('[data-row-prev],[data-row-next]').forEach(function (b) {
    b.addEventListener('click', function () {
      var row = b.closest('section').querySelector('.row-scroll'); if (!row) return;
      var dir = b.hasAttribute('data-row-next') ? 1 : -1;
      row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' });
    });
  });

  /* ---------- Sorted homepage rows (e.g. best selling) ---------- */
  $$('[data-sorted-url]').forEach(function (row) {
    var limit = parseInt(row.dataset.limit || '8', 10);
    fetch(row.dataset.sortedUrl).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = $$('[data-strip-src] > *', doc).slice(0, limit);
      if (cards.length) { row.innerHTML = ''; cards.forEach(function (c) { row.appendChild(document.importNode(c, true)); }); }
    }).catch(function () {});
  });

  /* ---------- Product recommendations ---------- */
  $$('[data-recs][data-url]').forEach(function (sec) {
    var load = function () {
      fetch(sec.dataset.url).then(function (r) { if (!r.ok) throw r; return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-recs-grid]');
        var current = sec.querySelector('[data-recs-grid]');
        if (grid && grid.children.length && current) current.replaceWith(document.importNode(grid, true));
        if (!sec.querySelector('[data-recs-grid] > *')) sec.hidden = true;
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (en) { return en.isIntersecting; })) { io.disconnect(); load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(sec);
    } else load();
  });
})();
